import { createContext } from "react";

const IssContext = createContext(null);

export default IssContext;
